export default function WinnerBlock() {
  return (
    <>
      <rect x="3" y="3" width="1083" height="328" rx="164" fill="#AAD4F9" />
      <rect
        x="3"
        y="3"
        width="1083"
        height="328"
        rx="164"
        fill="url(#paint0_linear_1331_16)"
      />
      <rect
        x="3"
        y="3"
        width="1083"
        height="328"
        rx="164"
        fill="url(#paint1_linear_1331_16)"
      />
      <rect
        x="3"
        y="3"
        width="1083"
        height="328"
        rx="164"
        fill="url(#paint2_linear_1331_16)"
      />
      <rect
        x="3"
        y="3"
        width="1083"
        height="328"
        rx="164"
        stroke="url(#paint3_linear_1331_16)"
        strokeWidth="6"
      />
      <rect
        x="3"
        y="3"
        width="1083"
        height="328"
        rx="164"
        stroke="url(#paint4_radial_1331_16)"
        strokeOpacity="0.59"
        strokeWidth="6"
      />
      <rect
        x="3"
        y="3"
        width="1083"
        height="328"
        rx="164"
        stroke="url(#paint5_radial_1331_16)"
        strokeOpacity="0.45"
        strokeWidth="6"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1331_16"
          x1="544.878"
          y1="333.394"
          x2="542.244"
          y2="-0.148216"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B1B78" />
          <stop offset="1" stopColor="#2946C7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1331_16"
          x1="346.5"
          y1="167"
          x2="0"
          y2="167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#011589" stopOpacity="0" />
          <stop offset="1" stopColor="#000B4A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1331_16"
          x1="853.5"
          y1="167"
          x2="1089"
          y2="167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#011589" stopOpacity="0" />
          <stop offset="1" stopColor="#000B4A" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1331_16"
          x1="544.5"
          y1="334"
          x2="544.5"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09196E" />
          <stop offset="1" stopColor="#1231D4" />
        </linearGradient>
        <radialGradient
          id="paint4_radial_1331_16"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(299.5 51.5) rotate(77.6289) scale(354.737 251.341)"
        >
          <stop stopColor="#70A3FB" />
          <stop offset="1" stopColor="#70A3FB" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_1331_16"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(893 17.5) rotate(170.525) scale(765.442 234.764)"
        >
          <stop stopColor="#70A3FB" />
          <stop offset="1" stopColor="#70A3FB" stopOpacity="0" />
        </radialGradient>
      </defs>
    </>
  );
}
